import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { LocaleProvider, message } from 'antd';
import { dequeueError } from '../actions/errorActions';
import esES from 'antd/lib/locale-provider/es_ES';
import enUS from 'antd/lib/locale-provider/en_US';
import ReduxConnectedIntlProvider from '../components/ReduxConnectedIntlProvider';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { changeBreadcrumbs } from '../actions/breadcrumbActions';
import { push } from 'react-router-redux';

// = styles =
// 3rd
import 'styles/antd.less';
import 'styles/drawer.css';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
import 'styles/dataFilter.scss';
import 'styles/dataTable.scss';
import 'styles/breadcrumbs.scss';
import 'styles/dashboard.scss';
import 'styles/login.scss';
import 'styles/reports.scss';
import 'styles/forgotPassword.scss';
import 'styles/settings/general/userProfile.scss';
import 'styles/settings/general/organization.scss';
import 'styles/settings/general/plant.scss';
import 'styles/settings/general/section.scss';
import 'styles/settings/monitoring/monitorables.scss';
import 'styles/settings/monitoring/variables.scss';
import 'styles/settings/devices/listing.scss';
import 'styles/settings/devices/scaled.scss';
import 'styles/settings/importData.scss';
import 'styles/editableTable.scss';
import 'styles/userAdminTable.scss';
import 'styles/dataFilterAnalytics.scss';
import 'styles/dataVisualization.scss';
import 'styles/analytics/general.scss';
import 'styles/reports/general.scss';
import 'styles/alerts/configuration.scss';
import 'styles/alerts/editableRulesCell.scss';
import 'styles/alerts/inProgress.scss';
import 'styles/alerts/history.scss';
import 'styles/alerts/configuration.scss';
import 'styles/alerts/editableRulesCell.scss';

class App extends Component {
  componentDidUpdate() {
    const { errorQueue, dequeueError } = this.props;
    if (errorQueue.length > 0) {
      message.error(errorQueue[errorQueue.length - 1]);
      dequeueError();
    }
  }
  componentDidMount() {
    const { lang, changeBreadcrumbs } = this.props;
    moment.locale(lang); // Sets correct initial language of moment to hole app. (DateLabel, Calendars, etc.)

    this.backListener = browserHistory.listen(location => {
      if (location.action === 'POP') {
        this.props.push('app/dashboard');
        changeBreadcrumbs([]);
      }
    });
  }

  render() {
    const { boxedLayout, fixedHeader, theme, lang } = this.props;

    // Sets correct locale for LocaleProvider.
    let locale = esES;
    if (lang === 'en') {
      locale = enUS;
    }

    return (
      <ReduxConnectedIntlProvider>
        <LocaleProvider locale={locale}>
          <div id="app-inner" className="full-height">
            <div className="preloaderbar hide">
              <span className="bar" />
            </div>
            <div
              id="app-main"
              className={classnames('full-height', {
                'fixed-header': fixedHeader,
                'boxed-layout': boxedLayout,
                'theme-gray': theme === 'gray',
                'theme-dark': theme === 'dark'
              })}
            >
              {this.props.children}
            </div>
          </div>
        </LocaleProvider>
      </ReduxConnectedIntlProvider>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    boxedLayout: state.settings.boxedLayout,
    fixedHeader: state.settings.fixedHeader,
    theme: state.settings.theme,
    lang: state.locale.lang,
    messages: state.locale.messages,
    errorQueue: state.error.errorQueue
  };
};

function mapDispatchToProps(dispatch) {
  return {
    dequeueError: () => {
      dispatch(dequeueError());
    },
    changeBreadcrumbs: breadcrumbs => {
      dispatch(changeBreadcrumbs(breadcrumbs));
    },
    push: url => {
      dispatch(push(url));
    }
  };
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./containers/App.js